import React, { Component } from "react";
import { baseTableConfig } from "../config";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import { saveAs } from "file-saver";
import FlexView from "react-flexview";

class ReportAsalProspek extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      config: [...baseTableConfig],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps?.doSearch !== this.props?.doSearch && this.props?.doSearch) {
      this.fetchData();
    }
  }

  transformProspekDataList = (list = []) => {
    return list.map((data) => {
      const result = {
        cabang: data.cabang,
        totalProspek: data.totalProspek,
      };

      Object.entries(data).forEach(([key, value]) => {
        if (typeof value === "object" && value?.percentage) {
          result[key] = value?.total || 0;
          result[`${key}Percentage`] = value.percentage;
        }
      });

      return result;
    });
  };

  fetchData = async () => {
    const {
      setError,
      isAllSelected,
      kodeCabang,
      cabangOptions,
      month,
      year,
      onTriggerLoading,
      onSuccessSearch,
    } = this.props;

    const cabang = isAllSelected ? cabangOptions : kodeCabang;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanStatistikAsalProspek,
      setError: setError,
      menuName: "Dashboard CRM Kabeng Kacab - Prospek Monitoring Asal Prospek",
      args: {
        listCabang: cabang?.map((item) => item.value),
        month: month?.value,
        year: year?.value,
      },
    });

    onTriggerLoading();
    onSuccessSearch();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      if (res.data.data.length === 0) {
        return;
      }

      const { cabang, totalProspek, ...skeleton } = res.data.data[0] || {};
      this.setState({
        dataTable: this.transformProspekDataList(res.data.data),
        config: [
          baseTableConfig[0],
          ...Object.entries(skeleton).flatMap(([key, value]) => [
            {
              name: key,
              label: value.source,
              options: {
                sort: false,
                setCellHeaderProps: () => ({
                  style: {
                    width: "100px",
                    minWidth: "100px",
                    textAlign: "center",
                  },
                }),
                setCellProps: () => ({
                  style: { textAlign: "center" },
                }),
              },
            },
            {
              name: `${key}Percentage`,
              label: `${value.source} (%)`,
              options: {
                sort: false,
                setCellHeaderProps: () => ({
                  style: {
                    width: "150px",
                    minWidth: "150px",
                    textAlign: "center",
                  },
                }),
                setCellProps: () => ({
                  style: { textAlign: "center" },
                }),
              },
            },
          ]),
          baseTableConfig[1],
        ],
      });
    }
  };

  mapRowByConfigLabel = (dataList = [], columns = []) => {
    return dataList.map((row) => {
      const result = {};

      columns.forEach((col) => {
        result[col.label] = row[col.name];
      });

      return result;
    });
  };

  handlePrint = async () => {
    const { dataTable, config } = this.state;
    const { onTriggerLoading, setError, month, year } = this.props;
    onTriggerLoading();

    const filename = `${year?.value}_${month.label}_Laporan_Statistik_Asal_Prospek`;
    const reqBody = {
      filename,
      sheets: [
        {
          name: "Laporan Statistik Asal Prospek",
          headers: config?.map((col) => col.label),
          data: this.mapRowByConfigLabel(dataTable, config),
        },
      ],
    };

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
      menuName: "Dashboard CRM Kabeng Kacab - Prospek Monitoring Asal Prospek",
      setError: setError,
      args: reqBody,
    });

    if (res?.ok) {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, `${reqBody.filename}.xlsx`);
    }
    onTriggerLoading();
  };

  render() {
    const { dataTable, config } = this.state;
    return (
      <React.Fragment>
        <SimpleDataTable
          data={dataTable}
          columns={config}
          options={{ pagination: false }}
        />
        <FlexView hAlignContent="right" className="margin-top-20px">
            <SimpleButton
              id="btn_print"
              text="Cetak"
              onClick={() => this.handlePrint()}
            />
        </FlexView>
      </React.Fragment>
    );
  }
}
export default ReportAsalProspek;
